import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_ROUND_ROBIN_ACTION } from "core/constants/Actions";
import {  getBracketRoundRobinResult } from "core/services/Bracket";

export function getRoundRobinResult(bracketId: string | number): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_ROUND_ROBIN_ACTION.REQUEST });
    const apiResponse = await getBracketRoundRobinResult(bracketId);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_ROUND_ROBIN_ACTION.SUCCESS,
        payload: { bracketResult: apiResponse.data.bracketResult },
      });
    } else {
      dispatch({
        type: BRACKET_ROUND_ROBIN_ACTION.FAILURE,
      });
    }
  };
}
